"use client";

import React, { useEffect, useState, useRef } from "react";
import scriptLoader from "react-async-script-loader";
import Autocomplete from "react-google-autocomplete";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import config from "../../../apiConfig";
import { checkValue } from "../../../helper/helper";
import api from "../../../api";
import MapLocationCard from "../cards/mapLocationCard";
import MobileFilterModal from "../modal/MobileFilterModal";
import OnlineStores from "../cards/OnlineStores";

const GMaps = (props) => {
  const {
    setStoreDataFromMap,
    // storeData,
    setStores,
    isScriptLoaded,
    isScriptLoadSucceed,
    // renderMapsAutoComplete,
    // mapCenter,
    userLocation,
    setUserLocation,
    mapId,
  } = props;

  const [showMapsAutoComplete, setShowMapsAutoComplete] = useState(false);

  const [show, setShow] = useState(true);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [showOnlineStore, setShowOnlineStore] = useState(false);
  const [hide, setHide] = useState(false);
  const [country, setCountry] = useState(null);
  const [settingCountry, setSettingCountry] = useState(false);
  const [barDataExists, setBarDataExists] = useState(false);
  const [storeDataExists, setStoreDataExists] = useState(false);

  const [newFormData, setNewFormData] = useState({
    latitude: "",
    longitude: "",
    stl_category_id: "",
    distance: 5,
  });

  const [storeData, setStoreData] = useState([]);
  const [storeDataCopy, setStoreDataCopy] = useState([]);
  const [storeDataForFilters, setStoreDataForFilters] = useState([]);
  const [onlineStores, setOnlineStores] = useState([]);
  const [fullMapData, setFullMapData] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [directionBaseURL, setDirectionBaseURL] = useState(
    "https://www.google.com/maps/dir"
  );
  const [mapCenter, setMapCenter] = useState({});
  const [defaultAutoCompleteVal, setDefaultAutoCompleteVal] = useState(null);
  const [storeBrandsData, setStoreBrandsData] = useState([]);
  const [currentBrand, setCurrentBrand] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);

  const handleClose = () => {
    setShowMobileFilter(!showMobileFilter);
  };

  const getStoreData = (params, callbackFunction) => {
    const myParams = {};
    api
      .getStoreLocatorData(myParams)
      .then((res) => {
        if (res && res.data) {
          let resp = [];
          let onlineStores = [];
          let onlineStoresObjects = [];
          res.data.map((item) => {
            let store_categories = [];
            let store_brands = [];
            if (item?.attributes?.latitude && item?.attributes?.longitude) {
              // creating online stores data
              if (
                item?.attributes?.online_store?.data?.attributes?.items
                  ?.length > 0
              ) {
                if (
                  item?.attributes?.online_store?.data?.attributes.is_active
                ) {
                  onlineStoresObjects.push(
                    item?.attributes?.online_store?.data?.attributes
                  );
                }
              }
              // end of creating online stores data
              item?.attributes?.store_categories?.data?.map((item) => {
                store_categories.push(item.attributes.name);
              });
              item?.attributes?.store_brands?.data?.map((item) => {
                store_brands.push(item.attributes.name);
              });
              resp.push({
                ...item.attributes,
                store_categories: store_categories,
                store_brands: store_brands,
              });
            }
          });
          let setObj = new Set(onlineStoresObjects.map(JSON.stringify));
          let output = Array.from(setObj).map(JSON.parse);
          output.map((out) => {
            out?.items?.map((item) => {
              if (item?.is_active) {
                onlineStores.push(item);
              }
            });
          });
          setStoreData(resp);
          setStoreDataCopy(resp);
          setStoreDataFromMap(resp);
          setStoreDataForFilters(resp);
          setOnlineStores(onlineStores);
          setFullMapData(res?.data);
          setSelectedData({});
        } else {
          setStoreData([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getStoreBrands = () => {
    const myParams = {};
    api
      .getStoreBrandsData(myParams)
      .then((res) => {
        if (res && res.data) {
          let resp = [];
          resp.push({
            label: "All",
            value: "all",
          });
          res.data.map((item) => {
            resp.push({
              label: item.attributes.name,
              value: item.attributes.name,
            });
          });
          setStoreBrandsData(resp);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (isScriptLoaded && isScriptLoadSucceed && !settingCountry) {
      getStoreData();
      getStoreBrands();
    }
  }, [isScriptLoaded, isScriptLoadSucceed]);

  const openGoogleMapsForDirections = (location, data) => {
    const url =
      directionBaseURL +
      "/" +
      location.coords.latitude +
      "," +
      location.coords.longitude +
      "/" +
      data.latitude +
      "," +
      data.longitude;
    window.open(url, "_blank");
  };

  const getDirections = (data) => {
    if (data.latitude && data.longitude) {
      if (userLocation && Object.keys(userLocation).length > 0) {
        openGoogleMapsForDirections(userLocation, data);
      } else {
        navigator.geolocation.getCurrentPosition((location) => {
          setUserLocation(location);
          openGoogleMapsForDirections(location, data);
        });
      }
    }
  };

  const fetchMyLocation = () => {
    setSettingCountry(true);
    navigator.geolocation.getCurrentPosition(
      (location) => {
        setUserLocation(location);
        setMapCenter({
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        });
        const json = {
          ...newFormData,
          latitude: location.coords.latitude,
          longitude: location.coords.longitude,
        };
        setNewFormData({ ...json });
        // getStoreData(json);
        if (google.maps) {
          const geocoder = new google.maps.Geocoder();
          const latlng = {
            lat: location.coords.latitude,
            lng: location.coords.longitude,
          };
          geocoder
            .geocode({ location: latlng })
            .then((response) => {
              if (response.results[0]) {
                if (response.results[0].address_components.length > 0) {
                  setCountry(
                    getCountryFromAddressComponents(
                      response.results[0].address_components
                    )
                  );
                }
                setSettingCountry(false);
                // setDefaultAutoCompleteVal(response.results[0].formatted_address)
                let city, state, country;
                for (
                  var i = 0;
                  i < response.results[0].address_components.length;
                  i++
                ) {
                  for (
                    var b = 0;
                    b < response.results[0].address_components[i].types.length;
                    b++
                  ) {
                    //there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
                    if (
                      response.results[0].address_components[i].types[b] ==
                      "administrative_area_level_1"
                    ) {
                      //this is the object you are looking for
                      state = response.results[0].address_components[i];
                    }
                    if (
                      !state &&
                      response.results[0].address_components[i].types[b] ==
                        "administrative_area_level_2"
                    ) {
                      //this is the object you are looking for
                      state = response.results[0].address_components[i];
                    }
                    if (
                      response.results[0].address_components[i].types[b] ==
                      "sublocality_level_1"
                    ) {
                      //this is the object you are looking for
                      city = response.results[0].address_components[i];
                    }
                    if (
                      !city &&
                      response.results[0].address_components[i].types[b] ==
                        "locality"
                    ) {
                      //this is the object you are looking for
                      city = response.results[0].address_components[i];
                    }
                    if (
                      response.results[0].address_components[i].types[b] ==
                      "country"
                    ) {
                      //this is the object you are looking for
                      country = response.results[0].address_components[i];
                    }
                  }
                }
                let formatted_address = "";
                if (city?.long_name) {
                  formatted_address += `${city?.long_name}`;
                }
                if (state?.short_name) {
                  formatted_address += `${city?.long_name ? "," : ""} ${
                    state?.short_name
                  }`;
                }
                if (country?.short_name) {
                  formatted_address += `${
                    city?.long_name || state?.short_name ? "," : ""
                  } ${country?.short_name}`;
                }
                setDefaultAutoCompleteVal(formatted_address);
                const input = refGMap.current;
                const inputMobile = refGMapMobile.current;
                if (input || inputMobile) {
                  input.value = formatted_address;
                  inputMobile.value = formatted_address;
                }
              } else {
                console.log("No results found");
              }
            })
            .catch((e) => console.log("Geocoder failed due to: " + e));
        }
      },
      () => {
        setUserLocation(null);
      }
    );
  };

  const gotoCurrentLocation = () => {
    fetchMyLocation();
  };

  useEffect(() => {
    const input = refGMap.current;
    const inputMobile = refGMapMobile.current;
    if (input && inputMobile) {
      input.value = defaultAutoCompleteVal;
      inputMobile.value = defaultAutoCompleteVal;
    }
  }, [defaultAutoCompleteVal]);

  function findKeyInObject(obj, key) {
    for (const prop in obj) {
      if (prop === key) {
        return obj[prop];
      } else if (typeof obj[prop] === "object") {
        const foundValue = findKeyInObject(obj[prop], key);
        if (foundValue !== undefined) {
          return foundValue;
        }
      }
    }
    return undefined;
  }

  useEffect(() => {
    if (isScriptLoaded && isScriptLoadSucceed) {
      let data = [...storeDataCopy];
      let sdata = [...fullMapData];
      if (data?.length > 0) {
        resetData();
      }
      if (country) {
        data = data.filter(
          (item) => findKeyInObject(item, "country_name") === country
        );
        let onlineStores = [];
        let onlineStoresObjects = [];
        sdata = sdata.filter(
          (item) => findKeyInObject(item, "country_name") === country
        );
        sdata.map((item) => {
          if (item?.attributes?.latitude && item?.attributes?.longitude) {
            if (
              item?.attributes?.online_store?.data?.attributes?.items?.length >
              0
            ) {
              if (item?.attributes?.online_store?.data?.attributes.is_active) {
                onlineStoresObjects.push(
                  item?.attributes?.online_store?.data?.attributes
                );
              }
            }
          }
        });
        let setObj = new Set(onlineStoresObjects.map(JSON.stringify));
        let output = Array.from(setObj).map(JSON.parse);
        output.map((out) => {
          out?.items?.map((item) => {
            if (item?.is_active) {
              onlineStores.push(item);
            }
          });
        });
        setOnlineStores(onlineStores);
      }
      setStoreDataForFilters(data);
      if (currentCategory) {
        data = data.filter((item) =>
          item.store_categories.includes(currentCategory)
        );
      }
      setStoreData(data);
    }
  }, [currentCategory, country, storeDataCopy, settingCountry, show]);

  const renderMapsAutoComplete = () => {
    setShowMapsAutoComplete(true);
  };

  const [mapComponent, setMapComponent] = useState(null);
  const [mobileMapComponent, setMobileMapComponent] = useState(null);
  const [mapProps, setMapProps] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [markerClusterer, setMarkerClusterer] = useState(null);
  const [markerClustererMobile, setMarkerClustererMobile] = useState(null);
  const [currectLocMarker, setCurrectLocMarker] = useState(null);

  const [mapZoom, setMapZoom] = useState(2.1);
  const refGMap = useRef(null);
  const refGMapMobile = useRef(null);

  useEffect(() => {
    if (isScriptLoaded && isScriptLoadSucceed) {
      if (userLocation === null) {
        // get current location on script load
        fetchMyLocation();
      }
      if (
        typeof document !== "undefined" &&
        (document.getElementById("map") || document.getElementById("mobileMap"))
      ) {
        if (!mapComponent) {
          if (document.getElementById("map")) {
            const map = new google.maps.Map(document.getElementById("map"), {
              center:
                mapCenter.lat && mapCenter.lng ? mapCenter : { lat: 0, lng: 0 },
              zoom: userLocation ? 5 : mapZoom,
              mapTypeControl: true,
              mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: google.maps.ControlPosition.TOP_CENTER,
              },
              zoomControl: true,
              zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER,
              },
              scaleControl: true,
              streetViewControl: true,
              streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
              },
              fullscreenControl: true,
            });
            setMapComponent(map);
          }
          renderMapsAutoComplete(true);
        } else {
          if (mapCenter.lat && mapCenter.lng) {
            mapComponent.setCenter(
              new google.maps.LatLng(mapCenter.lat, mapCenter.lng)
            );
            mapComponent.setZoom(userLocation ? 5 : mapZoom);
          }
          if (mapCenter.lat && mapCenter.lng) {
            mobileMapComponent?.setCenter(
              new google.maps.LatLng(mapCenter.lat, mapCenter.lng)
            );
            mobileMapComponent?.setZoom(userLocation ? 5 : mapZoom);
          }
        }

        if (!mobileMapComponent) {
          if (document.getElementById("mobileMap")) {
            const mobileMap = new google.maps.Map(
              document.getElementById("mobileMap"),
              {
                center:
                  mapCenter.lat && mapCenter.lng
                    ? mapCenter
                    : { lat: 0, lng: 0 },
                zoom: mapZoom,
                mapTypeControl: true,
                mapTypeControlOptions: {
                  style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                  position: google.maps.ControlPosition.TOP_CENTER,
                },
                zoomControl: true,
                zoomControlOptions: {
                  position: google.maps.ControlPosition.LEFT_CENTER,
                },
                scaleControl: true,
                streetViewControl: true,
                streetViewControlOptions: {
                  position: google.maps.ControlPosition.LEFT_TOP,
                },
                fullscreenControl: true,
              }
            );
            setMobileMapComponent(mobileMap);
          }
          renderMapsAutoComplete(true);
        } else {
          if (mapCenter.lat && mapCenter.lng) {
            mapComponent.setCenter(
              new google.maps.LatLng(mapCenter.lat, mapCenter.lng)
            );
            mapComponent.setZoom(mapZoom);
          }
          if (mapCenter.lat && mapCenter.lng) {
            mobileMapComponent?.setCenter(
              new google.maps.LatLng(mapCenter.lat, mapCenter.lng)
            );
            mobileMapComponent?.setZoom(mapZoom);
          }
        }
      }
    }
  }, [isScriptLoaded, isScriptLoadSucceed, mapCenter, storeData]);

  useEffect(() => {
    setTimeout(() => {
      renderUserCurrentLocation();
      if (storeData.length) {
        if (Boolean(mapComponent)) {
          setStoreMarkers(mapComponent);
        }
        if (Boolean(mobileMapComponent)) {
          setMobileStoreMarkers(mobileMapComponent);
        }
      }
    }, 1000);
  }, [storeData, mapComponent, mobileMapComponent, userLocation]);

  useEffect(() => {
    if (country) {
      let bar = storeDataForFilters.filter((item) =>
        item.store_categories.includes("Bar")
      );
      setBarDataExists(bar.length > 0);
      let store = storeDataForFilters.filter((item) =>
        item.store_categories.includes("Store")
      );
      setStoreDataExists(store.length > 0);
    } else {
      let bar = storeDataCopy.filter((item) =>
        item.store_categories.includes("Bar")
      );
      setBarDataExists(bar.length > 0);
      let store = storeDataCopy.filter((item) =>
        item.store_categories.includes("Store")
      );
      setStoreDataExists(store.length > 0);
    }
  }, [storeDataCopy, country, storeData]);

  const resetData = () => {
    // if (markers.length > 0) {
    setStoreData([]);
    setStores([]);
    setMapProps([]);
    markers.forEach((marker) => {
      marker.setMap(null);
    });
    setMarkers([]);

    if (document.getElementById("map") && mapComponent) {
      // Optionally, remove and recreate the map div to fully reset it
      document.getElementById("map").innerHTML = "";
      document.getElementById("map").remove();
      const mapDiv = document.createElement("div");
      mapDiv.id = "map";
      mapDiv.style.height = "100%";
      mapDiv.style.width = "100%";
      document.getElementById("google-maps-desktop").appendChild(mapDiv);
    }

    if (document.getElementById("mobileMap") && mobileMapComponent) {
      // Optionally, remove and recreate the map div to fully reset it
      document.getElementById("mobileMap").innerHTML = "";
      document.getElementById("mobileMap").remove();
      const mobileMapDiv = document.createElement("div");
      mobileMapDiv.id = "mobileMap";
      mobileMapDiv.style.height = "700px";
      mobileMapDiv.style.width = "100%";
      document.getElementById("google-maps-mobile").appendChild(mobileMapDiv);
    }

    if (markerClusterer) {
      markerClusterer?.clearMarkers();
    }
    if (markerClustererMobile) {
      markerClustererMobile?.clearMarkers();
    }

    setMarkerClusterer(null);
    setMarkerClustererMobile(null);
    setMapComponent(null);
    setMobileMapComponent(null);
    // }
  };

  const renderUserCurrentLocation = () => {
    if (!google.maps) return;
    if (!google.maps.Marker) return;

    if (!userLocation || !userLocation.coords) return;
    if (currectLocMarker) {
      currectLocMarker.setMap(null);
    }
    const marker = new google.maps.Marker({
      position: {
        lat: userLocation.coords.latitude,
        lng: userLocation.coords.longitude,
      },
      map: mapComponent,
      icon: renderCurrentLocMarker(),
    });
    setCurrectLocMarker(marker);
  };

  const renderGoogleMapMarker = (i) => {
    return {
      url: `/images/store-marker.svg`,
    };
  };

  const setMobileStoreMarkers = (mapComp) => {
    let removeMarkers = [...markers];
    for (let i = 0; i < removeMarkers.length; i++) {
      removeMarkers[i].setMap(null);
    }
    let infoWindow = null;
    setMarkers(removeMarkers);
    const arr = [];
    storeData.forEach((el, i) => {
      const marker = new google.maps.Marker({
        position: { lat: el.latitude, lng: el.longitude },
        // map: mapComp,
        icon: renderGoogleMapMarker(i),
      });
      marker.addListener("click", () => {
        if (infoWindow) {
          infoWindow.close();
        }
        infoWindow = new google.maps.InfoWindow();
        infoWindow.setContent(renderInfoWindowContent(el));
        infoWindow.open({
          anchor: marker,
          // map: mapComp,
          shouldFocus: false,
        });
        process.nextTick(() => {
          if (document.getElementById("mapDirections")) {
            const anchor = document.getElementById("mapDirections");
            anchor.addEventListener("click", function (event) {
              const lat = anchor.getAttribute("data-lat");
              const lng = anchor.getAttribute("data-lng");
              getDirections({ latitude: lat, longitude: lng });
            });
          }
        });
        // panMapToRight(marker);
      });
      if (i === 0) {
        // panMapToRight(marker);
      }
      arr.push(marker);
    });

    setMarkers(arr);
    const clusterer = new MarkerClusterer({
      markers: arr,
      map: mapComp,
    });
    setMarkerClustererMobile(clusterer);

    setStores(storeData);
  };

  const setStoreMarkers = (mapComp) => {
    let removeMarkers = [...markers];
    for (let i = 0; i < removeMarkers.length; i++) {
      removeMarkers[i].setMap(null);
    }
    setMarkers(removeMarkers);
    const arr = [];
    let infoWindow = null;
    storeData.forEach((el, i) => {
      const marker = new google.maps.Marker({
        position: { lat: el.latitude, lng: el.longitude },
        // map: mapComp,
        icon: renderGoogleMapMarker(i),
      });
      marker.addListener("click", () => {
        if (infoWindow) {
          infoWindow.close();
        }
        let content = renderInfoWindowContent(el);
        infoWindow = new google.maps.InfoWindow({
          content: content,
        });
        // infoWindow.setContent();
        infoWindow.open({
          anchor: marker,
          map: mapComp,
          shouldFocus: false,
        });
        process.nextTick(() => {
          if (document.getElementById("mapDirections")) {
            const anchor = document.getElementById("mapDirections");
            anchor.addEventListener("click", function (event) {
              const lat = anchor.getAttribute("data-lat");
              const lng = anchor.getAttribute("data-lng");
              getDirections({ latitude: lat, longitude: lng });
            });
          }
        });
        // panMapToRight(marker);
      });
      if (i === 0) {
        // panMapToRight(marker);
      }
      arr.push(marker);
    });

    setMarkers(arr);
    const clusterer = new MarkerClusterer({ markers: arr, map: mapComp });
    setMarkerClusterer(clusterer);

    setStores(storeData);
  };

  const renderStoreListItem = (storeItem) => {
    const defaultThumbImage = "/images/location-cardbg.png";

    let directionEl = "";
    let callEl = "";
    if (userLocation && userLocation.coords) {
      let url =
        "https://www.google.com/maps/dir/" +
        userLocation.coords.latitude +
        "," +
        userLocation.coords.longitude +
        "/" +
        storeItem?.latitude +
        "," +
        storeItem?.longitude +
        "";

      directionEl = `
        <a href='${url}' target='_blank' rel='noopener noreferer' class='shop-action-link'>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            fill="none"
            viewBox="0 0 16 17"
          >
            <path
              fill="#F9C467"
              d="M8.5 7A1.5 1.5 0 007 8.5V11a.5.5 0 01-1 0V8.5A2.5 2.5 0 018.5 6h.793l-.646-.647a.5.5 0 01.707-.707l1.5 1.5a.5.5 0 010 .707l-1.5 1.5a.5.5 0 11-.707-.707L9.293 7H8.5zM6.232 1.56a2.5 2.5 0 013.536 0l5.171 5.172a2.5 2.5 0 010 3.536L9.77 15.44a2.5 2.5 0 01-3.537 0l-5.17-5.17a2.5 2.5 0 010-3.537l5.17-5.172zm2.83.707a1.5 1.5 0 00-2.122 0L1.768 7.44a1.5 1.5 0 000 2.121l5.172 5.172a1.5 1.5 0 002.12 0l5.172-5.172a1.5 1.5 0 000-2.12l-5.17-5.173z"
            ></path>
          </svg>
          <span class='shop-action-text'>Directions</span>
        </a>
      `;
    }

    if (storeItem.phone_number) {
      callEl = `
        <a href='tel:${storeItem.phone_number}' target='_blank' rel='noopener noreferrer' class='shop-action-link'>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            fill="none"
            viewBox="0 0 16 17"
          >
            <path
              stroke="#F9C467"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.5 12.19v2.25a1.502 1.502 0 01-1.635 1.5 14.843 14.843 0 01-6.472-2.302 14.625 14.625 0 01-4.5-4.5A14.843 14.843 0 01.59 2.635 1.5 1.5 0 012.083 1h2.25a1.5 1.5 0 011.5 1.29 9.63 9.63 0 00.525 2.108A1.5 1.5 0 016.02 5.98l-.952.953a12 12 0 004.5 4.5l.952-.953a1.5 1.5 0 011.583-.337c.68.253 1.387.43 2.107.525a1.5 1.5 0 011.29 1.522z"
            ></path>
          </svg>
          <span class='shop-action-text'>Call</span>
        </a>
      `;
    }
   

    return `<div class="address-card custom-info-window">
        <img
          src="${storeItem?.company_logo?.data ? storeItem?.company_logo?.data?.attributes?.url : defaultThumbImage}"
          class='address-card__image'
          alt="${storeItem.company_name}"
          onError="(e) => this.src = ${defaultThumbImage}"
        />
        <div class='address-card__text d-flex flex-column justify-content-center'>
          <div>
            <h4 class="shop-name cursor-pointer mb-0">
              ${checkValue(storeItem?.company_name, "-")}
            </h4>
            <p
              class="new-address-card__desc"
            >
              ${checkValue(storeItem?.address_line_1, "-")}
              ${checkValue(storeItem?.address_line_2, ",")}
            </p>
          </div>
          <div class='shop-actions'>
            ${directionEl}
            ${callEl}
          </div>
        </div>
      </div>`;
  };

  const renderInfoWindowContent = (data) => {
    // let distance = 0;
    // if (userLocation && userLocation.coords) {
    //   distance = getDistance(
    //     {
    //       lat: userLocation.coords.latitude,
    //       lng: userLocation.coords.longitude,
    //     },
    //     { lat: data.latitude, lng: data.longitude }
    //   );
    // }

    const details = renderStoreListItem(data);
    return details;

    return (
      "<div class='address-card custom-info-window'>" +
      "<h4 class='shop-name'>!!" +
      data?.name +
      "</h4>" +
      "<p class='address-text'>" +
      data?.adress_line_1 +
      "</p>" +
      "<p class='address-text'>" +
      data?.adress_line_2 +
      "</p>" +
      (userLocation
        ? `<p class='directions mt-3'>${distance} from current location</p>`
        : "") +
      (userLocation
        ? `<p id="aWrapper" class='directions mt-3 action-link'><a id="mapDirections" href="javascript:void(0)" data-lat=` +
          data.lattitude +
          ` data-lng=` +
          data.longitude +
          `>GET Directions</a></p>`
        : "") +
      "</div>"
    );
  };

  const renderCurrentLocMarker = () => {
    return {
      url: `data:image/svg+xml;utf8,
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83 125" stroke="${encodeURIComponent(
        "#467fca"
      )}" stroke-width="1" fill="goldenrod">
        <circle xmlns="http://www.w3.org/2000/svg" cx="50" cy="95" r="5" fill="${encodeURIComponent(
          "#467fca"
        )}" style="fill-opacity: .25;"/>
        <circle xmlns="http://www.w3.org/2000/svg" cx="50" cy="95" r="3" fill="${encodeURIComponent(
          "#467fca"
        )}"/>
      </svg>
      `,
    };
  };

  const fetchDataFromPlace = (selectedPlace) => {
    if (selectedPlace) {
      const lat = selectedPlace.geometry.location.lat();
      const lng = selectedPlace.geometry.location.lng();
      setMapZoom(5);
      setMapCenter({ lat: lat, lng: lng });
    }
  };

  const MapInfoWindow = (shop) => {
    const map = new google.maps.Map(document.getElementById("map"), {
      center:
        mapCenter.lat && mapCenter.lng
          ? mapCenter
          : { lat: shop.latitude, lng: shop.longitude },
      zoom: 8,
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_CENTER,
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      scaleControl: true,
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
      },
      fullscreenControl: true,
    });

    setMapComponent(map);
    const marker = new google.maps.Marker({
      position: { lat: shop.latitude, lng: shop.longitude },
      // map: mapComp,
      icon: renderGoogleMapMarker(0),
    });
    let arr = [];
    const infoWindow = new google.maps.InfoWindow({
      content: renderStoreListItem(shop),
      position: { lat: shop.latitude, lng: shop.longitude },
    });
    infoWindow.open(map);
    arr.push(marker);
    setMarkers(arr);
    const clusterer = new MarkerClusterer({ markers: arr, map: mapComponent });
  };

  const mobileMapInfoWindow = (shop) => {
    const mobileMap = new google.maps.Map(
      document.getElementById("mobileMap"),
      {
        center: mapCenter.lat && mapCenter.lng ? mapCenter : { lat: 0, lng: 0 },
        zoom: 8,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_CENTER,
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_CENTER,
        },
        scaleControl: true,
        streetViewControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        fullscreenControl: true,
      }
    );

    // setMapComponent(map);
    setMobileMapComponent(mobileMap);
    const marker = new google.maps.Marker({
      position: { lat: shop.latitude, lng: shop.longitude },
      // map: mapComp,
      icon: renderGoogleMapMarker(0),
    });
    let arr = [];
    const infoWindow = new google.maps.InfoWindow({
      content: renderStoreListItem(shop),
      position: { lat: shop.latitude, lng: shop.longitude },
    });
    infoWindow.open(mobileMap);
    setMapCenter({ lat: shop.latitude, lng: shop.longitude });
    setMapZoom(8);
    // mobileMap.zoom=8
    arr.push(marker);
    setMarkers(arr);
    const clusterer = new MarkerClusterer({
      markers: arr,
      map: mobileMapComponent,
    });
    setMarkerClustererMobile(clusterer);
  };

  const openExtendedCard = (shop) => {
    MapInfoWindow(shop);
  };

  const openMobileExtendedCard = (shop) => {
    mobileMapInfoWindow(shop);
  };

  function getCountryFromAddressComponents(addressComponents) {
    for (const component of addressComponents) {
      if (component.types.includes("country")) {
        return component.long_name; // Or component.short_name for country code
      }
    }
    return null; // Country not found
  }

  return (
    <>
      <>
        <p className={"country-level-text"}>
          {showOnlineStore ? (
            <>Online Stores</>
          ) : (
            <>Country Level View | {storeData?.length} results</>
          )}
        </p>

        <div className="map-container onlyDesktop">
          <div className="map-innerleft_section">
            <div className="left-inner-section">
              <div className="top-section">
                <span className="location-text">Location</span>
                {/* <span
                  onClick={() => {
                    setCurrentBrand(null);
                  }}
                  className="clearall-btn"
                >
                  Clear All
                </span> */}
                {/* <span
                  className="down-arrow-container"
                  onClick={() => setHide(!hide)}
                >
                  {hide == true ? "Hide" : "Show"}
                </span> */}
              </div>
              {true && (
                <div className="middle-section">
                  {/* <div className="result-text">
                    See results: {storeData?.length}
                  </div> */}
                  {/* <div className="react-select-section">
                    <ReactSelectLocateUs
                      options={storeBrandsData}
                      selectedData={currentBrand}
                      onDataChange={setCurrentBrand}
                      placeholder={"-Select your drink-"}
                    />
                  </div> */}

                  <div className="react-select-search-section">
                    {isScriptLoaded && isScriptLoadSucceed && (
                      <span className="location-select">
                        <Autocomplete
                          ref={refGMap}
                          apiKey={config.GOOGLE_MAPS_API_KEY}
                          onPlaceSelected={(place) => {
                            if (place?.address_components) {
                              setCountry(
                                getCountryFromAddressComponents(
                                  place.address_components
                                )
                              );
                            }
                            fetchDataFromPlace(place);
                          }}
                          options={{
                            types: ["(regions)"],
                            fields: ["All"],
                          }}
                          defaultValue={defaultAutoCompleteVal}
                        />
                        <div
                          className="svg-container"
                          onClick={gotoCurrentLocation}
                        >
                          <img src="/svg/location.svg" className="location" />
                          <span></span>
                        </div>
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div className="card-section">
                {showOnlineStore ? (
                  <div className="online_store_text text-uppercase text-white">
                    <h2>Please check your online partners in your location</h2>
                  </div>
                ) : (
                  <MapLocationCard
                    storeData={storeData}
                    openExtendedCard={openExtendedCard}
                    getDirections={getDirections}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="map-inner-container">
            <div className={`location-data-container`}>
              <div className="d-none d-md-block">
                <div className="row location-data-container__row">
                  {showOnlineStore ? (
                    <OnlineStores onlineStores={onlineStores} />
                  ) : (
                    <div
                      className="google-maps-container"
                      id="google-maps-desktop"
                    >
                      <div
                        id={"map"}
                        style={{ height: "100%", width: "100%" }}
                      ></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {(barDataExists || storeDataExists || onlineStores?.length > 0) && (
            <div className="right-inner-section">
              <div className="top-section">
                <ul>
                  {barDataExists && (
                    <li
                      onClick={() => {
                        setCurrentCategory("Bar");
                        setShowOnlineStore(false);
                      }}
                      className={currentCategory == "Bar" ? "active" : ""}
                    >
                      Bar/Restaurant
                    </li>
                  )}
                  {storeDataExists && (
                    <li
                      onClick={() => {
                        setCurrentCategory("Store");
                        setShowOnlineStore(false);
                      }}
                      className={currentCategory == "Store" ? "active" : ""}
                    >
                      Store
                    </li>
                  )}
                  {country && onlineStores?.length > 0 && (
                    <li
                      onClick={() => {
                        setCurrentCategory("onlineStore");
                        setShowOnlineStore(true);
                      }}
                      className={
                        currentCategory == "onlineStore" ? "active" : ""
                      }
                    >
                      Online Stores
                    </li>
                  )}
                </ul>
              </div>
              <span
                onClick={() => {
                  setCurrentCategory(null);
                }}
              >
                Clear All
              </span>
            </div>
          )}
        </div>

        {/* for mobile only */}
        <div className="map-containerMobile onlyMobile">
          <div className="search-bar">
            <Autocomplete
              ref={refGMapMobile}
              apiKey={config.GOOGLE_MAPS_API_KEY}
              onPlaceSelected={(place) => {
                if (place?.address_components) {
                  setCountry(
                    getCountryFromAddressComponents(place.address_components)
                  );
                }
                fetchDataFromPlace(place);
              }}
              options={{
                types: ["(regions)"],
                fields: ["All"],
              }}
              defaultValue={defaultAutoCompleteVal}
            />
            <div className="svg-container">
              <img
                src="/svg/location.svg"
                className="location"
                onClick={gotoCurrentLocation}
              />
              <span></span>
              <img src="/svg/search.svg" />
            </div>
          </div>

          <div className="flip-container">
            {!showOnlineStore ? (
              <span onClick={() => setShow(!show)}>
                <>
                  {show ? (
                    <>
                      Map View <img src="/svg/map.svg" />
                    </>
                  ) : (
                    <>
                      List View <img src="/svg/list.svg" />
                    </>
                  )}
                </>
              </span>
            ) : (
              <>&span;</>
            )}
            {(barDataExists || storeDataExists || onlineStores?.length > 0) && (
              <img src="/svg/sliders.svg" alt="svg" onClick={handleClose} />
            )}
          </div>

          {show ? (
            <>
              {showOnlineStore ? (
                <OnlineStores onlineStores={onlineStores} />
              ) : (
                <div id="google-maps-mobile" className="map-inner-container">
                  <div
                    id={"mobileMap"}
                    style={{ width: "100%", height: "700px" }}
                  ></div>
                </div>
              )}
            </>
          ) : (
            <div className="card-section">
              <MapLocationCard
                storeData={storeData}
                openExtendedCard={(el) => {
                  setShow(true);
                  setTimeout(() => {
                    openMobileExtendedCard(el);
                  }, 1000);
                }}
                getDirections={getDirections}
              />
            </div>
          )}
          {showMobileFilter && (
            <MobileFilterModal
              setShowMobileFilter={setShowMobileFilter}
              showMobileFilter={showMobileFilter}
              storeBrandsData={storeBrandsData}
              setCurrentCategory={setCurrentCategory}
              setCurrentBrand={setCurrentBrand}
              setShowOnlineStore={setShowOnlineStore}
              currentCategory={currentCategory}
              country={country}
              onlineStores={onlineStores}
              barDataExists={barDataExists}
              storeDataExists={storeDataExists}
            />
          )}
        </div>
      </>
    </>
  );
};

export default scriptLoader([
  "https://maps.googleapis.com/maps/api/js?key=" +
    config.GOOGLE_MAPS_API_KEY +
    "&libraries=places",
])(GMaps);
